import React from 'react'
import { Controller, Control } from 'react-hook-form'
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap'

export interface Option {
  label: string
  value: string | number | null
}

interface Props {
  name: string
  control: Control<any>
  label: string
  options: Option[]
  isRequired?: boolean
}

const ICSSelectInput = ({
  name,
  control,
  label,
  options,
  isRequired
}: Props) => (
  <FormGroup>
    <Label for={name}>{label}</Label>
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <>
          <Input
            type="select"
            id={name}
            {...field}
            invalid={!!fieldState.error}
          >
            <option value="">
              {isRequired ? '-- Select Required --' : '-- Select --'}
            </option>
            {options.map((opt) => (
              <option key={String(opt.value)} value={opt.value ?? ''}>
                {opt.label}
              </option>
            ))}
          </Input>
          {fieldState.error && (
            <FormFeedback>{fieldState.error.message}</FormFeedback>
          )}
        </>
      )}
    />
  </FormGroup>
)

export default ICSSelectInput
